<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3 xl:w-1/4 sm:w-full mb-2">
        <div
          class="vx-card left-track-replay"
          :style="isSmallerScreen ? `max-height: 90vh` : `max-height: 80vh`"
        >
          <div class="tr-card-header">Track Replay</div>
          <div class="tr-card-body">
            <span class="title">{{
              `${
                typeof gps.device_name !== 'undefined'
                  ? gps.device_name
                  : 'Loading ...'
              } (IMEI: ${imei})`
            }}</span>

            <div class="vx-row mb-3 mt-3">
              <div class="vx-col w-full">
                <label class="vs-input--label">Start Time</label>
                <!-- minDate: last90days, -->
                <flat-pickr
                  :config="{
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    time_24hr: true,
                    defaultHour: 0
                  }"
                  style="width: 100%"
                  v-model="input.start"
                  placeholder="Start Time"
                />
              </div>
            </div>
            <div class="vx-row mb-3 mt-3">
              <div class="vx-col w-full">
                <label class="vs-input--label">End Time</label>
                <!-- minDate: last90days, -->
                <flat-pickr
                  :config="{
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    time_24hr: true,
                    defaultHour: 23,
                    defaultMinute: 59
                  }"
                  style="width: 100%"
                  v-model="input.end"
                  placeholder="End Time"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button
                  id="submitBtn"
                  class="vs-con-loading__container w-full"
                  @click="getTrack"
                  >Search</vs-button
                >
              </div>
            </div>
            <div v-if="this.markers.length > 0">
              <div class="tr-address">
                <table>
                  <tr>
                    <td>From</td>
                    <td>{{ address.from }}</td>
                  </tr>
                  <tr>
                    <td>Destination</td>
                    <td>{{ address.destination }}</td>
                  </tr>
                  <tr>
                    <td>Total Mileage</td>
                    <td>
                      <strong
                        >{{
                          totalMileage
                            .toString()
                            .replace('.', ',')
                            .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                        }}
                        Km</strong
                      >
                    </td>
                  </tr>
                </table>
              </div>
              <table class="tr-playback">
                <tr>
                  <td colspan="4" style="font-size: 13px">
                    Vehicle Mileage:
                    <strong
                      >{{
                        mileage.current
                          .toString()
                          .replace('.', ',')
                          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                      }}
                      Km</strong
                    >
                  </td>
                </tr>
                <!-- <tr>
                  <td colspan="3" style="font-size: 13px">
                    Total Mileage:
                    <strong
                      >{{
                        totalMileage
                          .toString()
                          .replace('.', ',')
                          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                      }}
                      Km</strong
                    >
                  </td>
                </tr> -->

                <tr>
                  <td rowspan="2" style="width: 15%">
                    <vs-button
                      :disabled="this.markers.length === 0"
                      radius
                      :color="play ? 'success' : '#9c9c9c'"
                      @click="togglePlay"
                      type="filled"
                      icon-pack="feather"
                      :icon="play ? 'icon-pause' : 'icon-play'"
                    ></vs-button>
                  </td>
                  <td colspan="2" width="80%">
                    <vs-slider
                      :disabled="this.markers.length === 0"
                      :color="play ? 'success' : '#9c9c9c'"
                      :max="slider.max"
                      v-model="slider.step"
                      style="width: 100%; margin: 10px 0px"
                    />
                  </td>
                  <td>
                    <vs-chip
                      class="float-right"
                      style="background: transparent"
                    >
                      <feather-icon
                        icon="FastForwardIcon"
                        class="cursor-pointer"
                        svgClasses="stroke-current w-10 h-5"
                        @click="set_speed()"
                      />
                      <span style="font-size: 12px; cursor: pointer"
                        >{{ speed_now }}x</span
                      >
                    </vs-chip>
                  </td>
                </tr>

                <tr>
                  <td colspan="2" style="text-align: top; font-size: 12px">
                    {{ slider.time }}
                  </td>
                  <td
                    class="float-right mr-5"
                    style="text-align: top; font-size: 12px"
                  >
                    {{ slider.speed }} Km/H
                  </td>
                </tr>
              </table>
              <div class="vx-row mb-3 mt-6">
                <div class="vx-col w-1/3" style="padding: 0px 5px 0px 10px">
                  <vs-button
                    size="small"
                    color="#9c9c9c"
                    style="width: 100%; font-size: 13px"
                    @click="reset"
                    >Reset</vs-button
                  >
                </div>
                <div class="vx-col w-1/3" style="padding: 0px 5px 0px 5px">
                  <vs-button
                    size="small"
                    :color="trackType === 'dots' ? 'success' : 'danger'"
                    style="width: 100%; font-size: 13px"
                    @click="toggleTrack"
                    >Dots</vs-button
                  >
                </div>
                <div class="vx-col w-1/3" style="padding: 0px 10px 0px 5px">
                  <vs-button
                    class="vs-con-loading__container"
                    id="exportBtn"
                    size="small"
                    color="warning"
                    style="width: 100%; font-size: 13px"
                    @click="exportTrack"
                    >Export</vs-button
                  >
                </div>
              </div>
              <div class="vx-row mb-3 mt-3">
                <!-- <div class="vx-col w-1/3" style="padding: 0px 5px 0px 10px">
                  <vs-button
                    size="small"
                    :color="stopPark ? 'success' : 'dark'"
                    style="width: 100%"
                    @click="showStopPark"
                    >Stop / Park</vs-button
                  >
                </div> -->

                <div class="vx-col w-1/3" style="padding: 0px 5px 0px 10px">
                  <vs-button
                    size="small"
                    :color="showStop ? 'success' : 'dark'"
                    style="width: 100%; font-size: 13px"
                    @click="setStop"
                    >Stop</vs-button
                  >
                </div>
                <div class="vx-col w-1/3" style="padding: 0px 5px 0px 5px">
                  <vs-button
                    size="small"
                    :color="showParking ? 'success' : 'primary'"
                    style="width: 100%; font-size: 13px"
                    @click="setParking"
                    >Parking</vs-button
                  >
                </div>
              </div>
            </div>
            <div v-else class="mt-3">
              <span v-if="loading">Loading ...</span>
              <code v-else>No Track Data</code>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col w-full lg:w-2/3 xl:w-3/4 sm:w-full">
        <div class="vx-card p-3">
          <l-map
            class="map"
            ref="peta"
            :center.sync="map.center"
            :zoom="map.zoom"
            :options="mapOptions"
            :style="isSmallerScreen ? `min-height: 85vh` : `min-height: 77vh`"
          >
            <l-control-layers position="bottomleft"></l-control-layers>

            <l-control
              position="bottomleft"
              style="width: 100%; margin-right: 4%"
            >
              <vs-button
                @click="showPolygone('speed_zone')"
                type="filled"
                :color="show_hide_color.speed_zone"
                title="Show Speed Limit by Zone"
                class="btn_poi"
                ><img
                  src="@/assets/images/file-icons/speed_zone.svg"
                  alt=""
                  width="18"
                  :style="
                    show_hide.speed_zone
                      ? 'filter: invert(100%)'
                      : 'filter: invert(0%)'
                  "
              /></vs-button>
            </l-control>
            <l-control
              position="bottomleft"
              style="width: 100%; margin-right: 4%"
            >
              <vs-button
                @click="showPolygone('geofence')"
                type="filled"
                :color="show_hide_color.geofence"
                title="Show Geofence"
                class="btn_poi"
                ><img
                  src="@/assets/images/file-icons/geofence.svg"
                  alt=""
                  width="18"
                  :style="
                    show_hide.geofence
                      ? 'filter: invert(100%)'
                      : 'filter: invert(0%)'
                  "
              /></vs-button>
            </l-control>

            <l-control
              position="bottomleft"
              style="width: 100%; margin-right: 4%"
            >
              <vs-button
                @click="showPolygone('poi')"
                type="filled"
                :color="show_hide_color.poi"
                :title="'One Click to show All POI \nDouble Click to show All POI Name'"
                class="btn_poi"
              >
                <img
                  src="@/assets/images/file-icons/poi.svg"
                  alt=""
                  width="18"
                  :style="
                    show_hide.poi
                      ? 'filter: invert(100%)'
                      : 'filter: invert(0%)'
                  "
                />
              </vs-button>
            </l-control>

            <l-control-polyline-measure
              :options="{ showUnitControl: false }"
              position="topleft"
            />

            <l-control-zoom
              position="bottomright"
              class="zoom-control"
            ></l-control-zoom>

            <l-control-fullscreen
              position="bottomright"
              :options="{
                title: { false: 'Fullscreen', true: 'RegularScreen' }
              }"
            />

            <l-control
              position="bottomright"
              title="Google Map"
              class="example-custom-control2"
            >
              <img
                src="@/assets/images/file-icons/google-maps.png"
                width="30"
                alt="Google Map"
                @click="openGoogleMap"
              />
            </l-control>

            <l-control
              position="topleft"
              class="example-custom-control"
              title="Street View"
              style="cursor: pointer"
            >
              <img
                src="https://img.gps.id/assets/icons/icon_streetview.png"
                width="28"
                alt="Street View"
                @click="streetView"
              />
            </l-control>

            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
              :options="{ maxZoom: 22 }"
            />

            <!-- Start Sign -->
            <l-marker
              :lat-lng="markerStart.position"
              :icon="markerStart.icon"
              :visible="markerStart.visible"
            />
            <!-- Finish Sign -->
            <l-marker
              :lat-lng="markerFinish.position"
              :icon="markerFinish.icon"
              :visible="markerFinish.visible"
            />
            <l-rotated-marker
              v-for="(item, index) in markers"
              :key="index"
              :lat-lng="item.position"
              :icon="item.icon"
              :rotationAngle="item.angle"
              :visible="item.visible"
            >
            </l-rotated-marker>
            <l-polyline :lat-lngs="polyline" color="purple"> </l-polyline>

            <l-layer-group :visible="trackType === 'dots' && isPermanent">
              <l-marker
                v-for="(item, index) in dots"
                :key="index"
                :lat-lng="item.position"
              >
                <l-tooltip
                  :options="{
                    permanent: true,
                    interactive: true,
                    direction: 'right',
                    className: 'leaflet-tooltip'
                  }"
                >
                  Time: {{ item.time }}, Speed: {{ item.speed }} Km/h
                </l-tooltip>
              </l-marker>
            </l-layer-group>

            <l-layer-group :visible="trackType === 'dots' && !isPermanent">
              <l-marker
                v-for="(item, index) in dots"
                :key="index"
                :lat-lng="item.position"
              >
                <l-tooltip
                  :options="{
                    permanent: false,
                    interactive: true,
                    direction: 'right',
                    className: 'leaflet-tooltip'
                  }"
                >
                  Time: {{ item.time }}, Speed: {{ item.speed }} Km/h
                </l-tooltip>
              </l-marker>
            </l-layer-group>

            <!-- Stop Sign -->
            <l-layer-group>
              <l-marker
                v-for="(item, i) in stopSign"
                :key="i"
                :lat-lng="item.position"
                :icon="item.icon"
              >
                <l-popup
                  style="min-height: 110px"
                  class="leaflet-popup-content"
                >
                  <div
                    class="leaflet-popup-header"
                    style="text-align: center; font-size: 16px; color: white"
                    :style="`background-color:${item.color}`"
                  >
                    {{ item.status_name }}
                  </div>
                  <div
                    style="
                      text-align: center;
                      font-size: 16px;
                      font-weight: 600;
                    "
                  >
                    {{ secondsToHms(item.total_time) }}
                  </div>

                  <div
                    style="
                      text-align: center;
                      font-size: 14.5px;
                      padding-top: 5px;
                      font-weight: 600;
                    "
                  >
                    Start: {{ item.start }} - End: {{ item.end }}
                  </div>

                  <div
                    style="
                      text-align: center;
                      font-size: 14px;
                      padding-top: 5px;
                      padding-bottom: 10px;
                      padding-left: 10px;
                      padding-right: 10px;
                    "
                  >
                    {{ item.address }}
                  </div>
                </l-popup>
              </l-marker>
            </l-layer-group>

            <l-layer-group>
              <l-marker
                v-for="(item, i) in parkingSign"
                :key="i"
                :lat-lng="item.position"
                :icon="item.icon"
              >
                <l-popup
                  style="min-height: 110px"
                  class="leaflet-popup-content"
                >
                  <div
                    class="leaflet-popup-header"
                    style="text-align: center; font-size: 16px; color: white"
                    :style="`background-color:${item.color}`"
                  >
                    {{ item.status_name }}
                  </div>
                  <div
                    style="
                      text-align: center;
                      font-size: 16px;
                      font-weight: 600;
                    "
                  >
                    {{ secondsToHms(item.total_time) }}
                  </div>
                  <div
                    style="
                      text-align: center;
                      font-size: 14.5px;
                      padding-top: 5px;
                      font-weight: 600;
                    "
                  >
                    Start: {{ item.start }} - End: {{ item.end }}
                  </div>

                  <div
                    style="
                      text-align: center;
                      font-size: 14px;
                      padding-top: 5px;
                      padding-bottom: 10px;
                      padding-left: 10px;
                      padding-right: 10px;
                    "
                  >
                    {{ item.address }}
                  </div>
                </l-popup>
              </l-marker>
            </l-layer-group>

            <template>
              <l-control position="topright" class="d-flex">
                <div
                  class="switch p-3"
                  style="font-family: 'Poppins', sans-serif"
                >
                  <vs-switch
                    v-model="showDotsDetail"
                    color="#28C76F"
                    class="switch-button"
                    name="switch-button"
                  />
                  <span>Dots Speed</span>
                </div>
              </l-control>
            </template>

            <!-- =============== START POI POLYGONE ================= -->

            <l-layer-group :visible="isPermanentPoi">
              <l-polygon
                v-for="item in poi.polygon"
                :key="item.id"
                :lat-lngs="item.latlngs"
                :visible="show_hide.poi == true"
              >
                <l-tooltip
                  :options="{
                    interactive: true,
                    permanent: true,
                    direction: 'top',
                    className: 'leaflet-tooltip'
                  }"
                  >POI : {{ item.name }}</l-tooltip
                >
                <!-- <l-popup>
                  <div class="leaflet-popup-header">Point of Interest</div>
                  <table class="leaflet-popup-table">
                    <tr>
                      <td>POI Name</td>
                      <td>{{ item.name }}</td>
                    </tr>
                  </table>
                </l-popup> -->
              </l-polygon>
            </l-layer-group>

            <l-layer-group :visible="!isPermanentPoi">
              <l-polygon
                v-for="item in poi.polygon"
                :key="item.id"
                :lat-lngs="item.latlngs"
                :visible="show_hide.poi == true"
              >
                <l-tooltip
                  :options="{
                    interactive: true,
                    permanent: false,
                    direction: 'top',
                    className: 'leaflet-tooltip'
                  }"
                  >POI : {{ item.name }}</l-tooltip
                >
              </l-polygon>
            </l-layer-group>

            <!-- =============== END POI POLYGONE ================= -->

            <!-- =============== START POI MARKER ================= -->

            <l-layer-group :visible="isPermanentPoi">
              <l-marker
                v-for="item in poi.marker"
                :key="item.id"
                :lat-lng="item.latlngs"
                :icon="item.icon"
                :visible="show_hide.poi == true"
              >
                <l-tooltip
                  :options="{
                    interactive: true,
                    permanent: true,
                    direction: 'top',
                    className: 'leaflet-tooltip'
                  }"
                  >POI : {{ item.name }}</l-tooltip
                >
              </l-marker>
            </l-layer-group>

            <!-- =============== END POI MARKER ================= -->

            <l-polygon
              v-for="(item, index) in zone_speed.polygon"
              :key="'B' + index"
              :lat-lngs="item.latlngs"
              :color="item.color"
              :fillColor="item.color"
              :visible="show_hide.speed_zone == true"
            >
              <l-popup>
                <div class="leaflet-popup-header">Speed By Zone</div>
                <table class="leaflet-popup-table">
                  <tr>
                    <td>Zone Name</td>
                    <td>{{ item.name }}</td>
                  </tr>
                  <tr>
                    <td>Speed Limit</td>
                    <td>{{ item.speed }} Km/h</td>
                  </tr>
                </table>
              </l-popup>
            </l-polygon>

            <l-polygon
              v-for="(item, index) in geofence.polygon_in"
              :key="'IN' + index"
              :lat-lngs="item.latlngs"
              :color="item.color"
              :fillColor="item.color"
              :visible="show_hide.geofence == true"
            >
              <l-popup>
                <div class="leaflet-popup-header">Geofence Zone</div>
                <table class="leaflet-popup-table">
                  <tr>
                    <td>Geofence Name</td>
                    <td>{{ item.name }}</td>
                  </tr>
                  <tr>
                    <td>Geofence Type</td>
                    <td>{{ item.type }}</td>
                  </tr>
                </table>
              </l-popup>
            </l-polygon>

            <l-polygon
              v-for="(item, index) in geofence.polygon_out"
              :key="'OUT' + index"
              :lat-lngs="item.latlngs"
              :color="item.color"
              :fillColor="item.color"
              :visible="show_hide.geofence == true"
            >
              <l-popup>
                <div class="leaflet-popup-header">Geofence Zone</div>
                <table class="leaflet-popup-table">
                  <tr>
                    <td>Geofence Name</td>
                    <td>{{ item.name }}</td>
                  </tr>
                  <tr>
                    <td>Geofence Type</td>
                    <td>{{ item.type }}</td>
                  </tr>
                </table>
              </l-popup>
            </l-polygon>
          </l-map>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.leaflet-tooltip {
  position: absolute;
  margin: 5px;
  background-color: #1da1f2 !important;
  border: 1px solid white;
  border-radius: 8px 8px;
  color: white;
  font-size: 12.5px;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.map .switch {
  margin-inline: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.map .switch span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
}

.map .switch .switch-button {
  border-radius: 25px;
}

.btn_poi {
  z-index: 1000;
  border: 0.16em solid rgb(169, 169, 169);
  border-radius: 0.4em;
  margin-right: 0.1em;
  width: 48px;
  height: 48px;
  padding: 0px !important;
}

.btn_poi img {
  margin-top: 0px;
  margin-left: 0px;
}

.animation-icon {
  transition-duration: 1s;
  transition-timing-function: linear;
}

.animation-icon_speed2 {
  transition-duration: 0.5s;
  transition-timing-function: linear;
}

.animation-icon_speed3 {
  transition-duration: 0.2s;
  transition-timing-function: linear;
}

.animation-icon-default {
  /* transition-duration: 0.5s; */
  transition-timing-function: linear;
}
/* .leaflet-popup-content {
  max-width: 150px;
  height: 70px;
} */

.example-custom-control {
  background: #fff;
  padding: 0.5em 0.1em;
  border: 0.2em solid rgb(169, 169, 169);
  border-radius: 0.4em;
}

.example-custom-control2 {
  cursor: pointer;
  padding: 1.5px 1px;
  background: #fff;
  border: 1.8px solid rgb(169, 169, 169);
  border-radius: 0.4em;
  margin-right: 0.1em;
  width: 35px;
  height: 38px;
  padding: 0px !important;
  /* box-shadow: 4px 4px 6px 2px rgba(0, 0, 0, 0.55);
  -moz-box-shadow: 12px 8px 6px 1px rgba(0, 0, 0, 0.48); */
}

.example-custom-control2 img {
  margin-left: 1.2px;
  margin-top: 1.5px;
}
</style>

<script>
import L from 'leaflet'
import {
  LMap,
  LTileLayer,
  LPolyline,
  LLayerGroup,
  LMarker,
  LControlLayers,
  LPolygon,
  LPopup,
  LTooltip,
  LControl,
  LControlZoom
} from 'vue2-leaflet'
import LControlPolylineMeasure from 'vue2-leaflet-polyline-measure'
import vSelect from 'vue-select'
import LRotatedMarker from 'vue2-leaflet-rotatedmarker'

import 'leaflet/dist/leaflet.css'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import FileDownload from 'js-file-download'

import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

import LControlFullscreen from 'vue2-leaflet-fullscreen'

export default {
  components: {
    vSelect,
    LMap,
    LTileLayer,
    LRotatedMarker,
    LPolyline,
    LLayerGroup,
    LMarker,
    LControlLayers,
    flatPickr,
    LControlPolylineMeasure,
    LPolygon,
    LPopup,
    LTooltip,
    LControl,
    LControlFullscreen,
    LControlZoom
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      data: [],
      actor: {},
      imei: '',
      gps: {},
      token: '',
      tileProviders: [
        {
          name: 'Google Street',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Traffic',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=m@221097413,traffic&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ],
      map: {
        center: L.latLng(-6.21011, 106.832459),
        zoom: 13
      },

      mapOptions: {
        // zoomSnap: 0.5
        zoomControl: false
      },

      input: {
        start: '',
        end: ''
      },

      export: {
        start: '',
        end: ''
      },

      poi: {
        marker: [],
        polygon: []
      },

      zone_speed: {
        polygon: []
      },

      geofence: {
        polygon_in: [],
        polygon_out: []
      },

      play: false,
      slider: {
        max: 50,
        step: 0,
        step_temp: 0,
        time: '',
        speed: 0,
        lat: '',
        lon: ''
      },

      speed_track: 1000,
      speed_now: 1,
      class_animation: true,

      tracks: [],
      trackType: 'line',
      defautlPolyline: [],
      polyline: [],
      defaultDots: [],
      dots: [],
      address: {
        from: '',
        destination: ''
      },

      totalMileage: 0,
      mileage: {
        current: 0,
        total: 0
      },

      markers: [],
      markerStart: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: process.env.BASE_URL + 'markers/start.png',
          iconSize: [50, 50],
          iconAnchor: [25, 48]
        }),
        visible: false
      },
      markerFinish: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: process.env.BASE_URL + 'markers/finish.png',
          iconSize: [50, 50],
          iconAnchor: [25, 48]
        }),
        visible: false
      },

      interval: '',
      notify: 'Server Error',
      loading: true,

      defaultStopSign: [],
      stopSign: [],
      parkingSign: [],
      marker_stop: [],
      marker_parking: [],

      show_hide: {
        poi: false,
        geofence: false,
        speed_zone: false
      },

      show_hide_color: {
        poi: 'white',
        geofence: 'white',
        speed_zone: 'white'
      },

      stopPark: false,
      stopParkNumber: 0,
      stopParkStatus: '',
      last_map_position: [],
      temp_angle: 0,

      showStop: true,
      showParking: true,
      showDotsDetail: false,
      isPermanent: false,
      isPermanentPoi: false,
      clicks: 0
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 992
    },

    step() {
      if (
        this.slider.step_temp == this.slider.step ||
        this.slider.step_temp + 1 == this.slider.step ||
        this.slider.step_temp - 1 == this.slider.step
      )
        this.class_animation = true
      else this.class_animation = false

      this.slider.step_temp = this.slider.step
      return this.slider.step
    },

    last90days() {
      const date = new Date()
      date.setDate(date.getDate() - 90)

      return date
    },

    show_dots_detail() {
      return this.showDotsDetail
    }
  },

  watch: {
    show_dots_detail(val) {
      if (val) this.isPermanent = true
      else this.isPermanent = false
    },

    step(val) {
      if (this.tracks.length > 0) {
        const data = this.tracks[val]
        // const dataAfter = this.tracks[val+1]
        // console.log(data)
        this.slider.time = data.time
        this.slider.speed = data.speed
        this.slider.lat = parseFloat(data.lat)
        this.slider.lon = parseFloat(data.lon)
        this.map.center = L.latLng(parseFloat(data.lat), parseFloat(data.lon))

        // if(val == 0)
        //   this.mileage.total = 0
        // else if(val > oldVal)
        //   this.mileage.total = this.mileage.total + parseInt(data.mileage - this.tracks[val-1].mileage)
        // else {
        //   this.mileage.total = this.mileage.total - parseInt(this.tracks[val+1].mileage - data.mileage)
        // }

        this.mileage.current = (data.mileage / 1000).toFixed(2)

        // this.mileage.total = this.mileage.current + ((data.mileage-this.tracks[val-1].mileage)/1000).toFixed(2)
        // this.mileage.current = (data.mileage/1000).toFixed(2)

        // this.polyline = this.defautlPolyline.slice(0, val + 1)
        this.dots = this.defaultDots.slice(0, val)

        // this.stopSign = this.defaultStopSign.filter((l, i) => {
        // return l.index <= val
        // })

        // this.defaultStopSign.filter((l, i) => {
        //   if (l.position.lng == data.lon) this.stopSign.push(l)
        // })

        // this.polyline.push(L.latLng(data.lat, data.lon))
        // this.map.center = L.latLng(data.lat, data.lon)
        this.markers[0].position = L.latLng(data.lat, data.lon)
        this.markers[0].angle = data.angle
        this.last_map_position = [
          {
            lat: parseFloat(data.lat),
            lon: parseFloat(data.lon)
          }
        ]

        let animasi =
          this.class_animation && this.speed_now == 1
            ? 'animation-icon'
            : this.class_animation && this.speed_now == 2
            ? 'animation-icon_speed2'
            : this.class_animation && this.speed_now == 3
            ? 'animation-icon_speed3'
            : 'animation-icon-default'

        this.markers[0].icon = L.icon({
          iconUrl: `${this.gps.fullpath_icon.acc_on}`,
          iconSize: [32, 32],
          className:
            data.angle - this.temp_angle > 50 ||
            data.angle - this.temp_angle < -50
              ? ''
              : animasi
        })
        this.temp_angle = data.angle
      }
    },

    play() {
      // if (this.stopPark) {
      //   this.stopPark = false
      //   this.slider.step = 0
      //   this.stopSign = []
      // }

      if (this.play) {
        this.interval = setInterval(() => {
          if (this.slider.step < this.slider.max) {
            this.slider.step++
          } else {
            this.play = false
            // this.slider.step = 0
            clearInterval(this.interval)
          }
        }, this.speed_track)
      } else {
        if (this.interval) clearInterval(this.interval)
      }
    },

    speed_now: {
      handler(val) {
        this.play = !this.play
      }
    }
  },

  created() {
    this.imei = this.$route.params.imei
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.getGpsDetail()
        this.getZoneSpeedList()
        this.getPoiList()
        this.getGeofenceZone()

        let today = new Date()
        let date = `${today.getFullYear()}-${(today.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`

        this.input.start = `${date} 00:00`
        // this.input.end = `${date} ${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}`
        this.input.end = `${date} 23:59`

        // this.input.start = '2020-02-12 20:00'
        // this.input.end = '2020-02-13 12:00'
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    getAddress(latlng, target, index) {
      this.$http
        .get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: latlng.lat,
            longitude: latlng.lon
          }
        })
        .then((res) => {
          this[target][index] = res.data.message
        })
    },

    togglePlay() {
      // if(!this.play && this.slider.step === this.slider.max) this.slider.step = 0
      this.play = !this.play
    },

    getGpsDetail() {
      this.$http
        .get(`${this.$api.endpoint}/gps/detail/${this.imei}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.gps = res.data.message.data
          // this.map.center = L.latLng(this.gps.lat, this.gps.lon)
          this.getTrack()
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getPoiList() {
      this.$http
        .get(`${this.$api.endpoint}/poi/general`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          //console.log(data)

          data.map((item, index) => {
            let target = item.type === 0 ? 'marker' : 'polygon'
            let latlngs =
              item.type === 0
                ? L.latLng(item.lat, item.lon)
                : this.geomToPolygon(item.geom)

            this.poi[target].push({
              id: item.id,
              name: item.name,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              icon: item.icon
                ? L.icon({
                    iconUrl: `${
                      item.icon.fullpath_icon
                        ? item.icon.fullpath_icon
                        : item.icon.icon
                    }`,
                    iconSize: [20, 20]
                  })
                : L.icon.Default
            })
          })
        })
        .catch((error) => {})
    },

    getZoneSpeedList() {
      this.$http
        .get(`${this.$api.endpoint}/speed_limit_by_zone/all_zone`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          //console.log(data)

          data.map((item, index) => {
            let target = 'polygon'
            let latlngs = this.geomToPolygon(item.geom)

            this.zone_speed[target].push({
              id: item.id,
              name: item.name,
              speed: item.speed,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              color: '#B8860B'
            })
          })
        })
        .catch((error) => {})
    },

    getGeofenceZone() {
      this.$http
        .get(`${this.$api.endpoint}/zone/geofence_zone`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data

          data.map((item, index) => {
            let target = item.type == 0 ? 'polygon_in' : 'polygon_out'
            let latlngs = this.geomToPolygon(item.geom)

            this.geofence[target].push({
              id: item.id,
              name: item.name,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              color: item.type == 0 ? 'red' : 'green',
              type: item.type == 0 ? 'IN' : 'OUT'
            })
          })
        })
        .catch((error) => {})
    },

    geomToPolygon(geom) {
      let start = '(('
      let end = '))'

      geom = geom.substring(
        geom.indexOf(start) + start.length,
        geom.indexOf(end)
      )

      let latlon = geom.split(',')

      let result = []
      latlon.map((item) => {
        let x = item.split(' ')
        result.push([parseFloat(x[1]), parseFloat(x[0])])
      })

      return result
    },

    getTrack() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      this.markers = []
      this.polyline = []
      this.defautlPolyline = []
      this.play = false
      this.tracks = []
      this.defaultStopSign = []
      this.stopSign = []

      this.slider.time = '-'
      this.slider.speed = '-'
      this.slider.step = 0
      this.loading = true
      this.stopPark = false
      this.temp_angle = 0

      this.$http
        .get(`${this.$api.endpoint}/tracking/track/${this.imei}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            start: `${this.input.start}:00`,
            end: `${this.input.end}:00`
          }
        })
        .then((res) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.loading = false

          this.export.start = this.input.start
          this.export.end = this.input.end

          if (res.data.message.data.length > 0) {
            this.tracks = res.data.message.data
            this.totalMileage = (
              (this.tracks[this.tracks.length - 1].mileage -
                this.tracks[0].mileage) /
              1000
            ).toFixed(2)
            this.mileage.current = (this.tracks[0].mileage / 1000).toFixed(2)

            this.getAddress(
              { lat: this.tracks[0].lat, lon: this.tracks[0].lon },
              'address',
              'from'
            )
            this.getAddress(
              {
                lat: this.tracks[this.tracks.length - 1].lat,
                lon: this.tracks[this.tracks.length - 1].lon
              },
              'address',
              'destination'
            )

            this.slider.lat = this.tracks[0].lat
            this.slider.lon = this.tracks[0].lon

            // this.address.from = this.tracks[0].address
            // this.address.destination = this.tracks[this.tracks.length-1].address

            this.slider.max = this.tracks.length - 1
            this.slider.time =
              this.tracks.length > 0 ? this.tracks[0].time : '-'
            this.slider.speed =
              this.tracks.length > 0 ? this.tracks[0].speed : '0'

            let lastStop = false
            let lastPark = false
            const lastData = {
              speed: '',
              time: '',
              acc: ''
            }

            this.dots = []
            this.defaultDots = []

            // init start marker
            ;(this.markerStart.position = L.latLng(
              this.tracks[0].lat,
              this.tracks[0].lon
            )),
              (this.markerStart.visible = true)

            // init finish marker
            ;(this.markerFinish.position = L.latLng(
              this.tracks[this.tracks.length - 1].lat,
              this.tracks[this.tracks.length - 1].lon
            )),
              (this.markerFinish.visible = true)

            this.stopParkNumber = 0
            this.stopParkStatus = ''
            this.tracks.map((item, index) => {
              this.defautlPolyline.push(L.latLng(item.lat, item.lon))
              const time = item.time.split(' ')
              let x = {
                position: L.latLng(item.lat, item.lon),
                time: time[1],
                speed: item.speed
              }
              this.defaultDots.push(x)

              lastData.time = item.time
              lastData.speed = item.speed
            })

            const data = this.tracks[0]

            // this.polyline.push(L.latLng(data.lat, data.lon))
            this.polyline = this.defautlPolyline
            this.map.center = L.latLng(data.lat, data.lon)

            const x = {
              visible: true,
              position: L.latLng(data.lat, data.lon),
              angle: data.angle
            }

            if (this.gps.icon)
              x.icon = L.icon({
                iconUrl: `${this.gps.fullpath_icon.acc_on}`,
                iconSize: [32, 32]
                // className: 'animation-icon'
              })
            else {
              x.icon = L.icon.Default
            }

            this.markers.push(x)

            this.last_map_position = [
              {
                lat: parseFloat(this.tracks[0].lat),
                lon: parseFloat(this.tracks[0].lon)
              }
            ]
          }

          this.markerStop()
          this.markerParking()

          if (this.defaultStopSign.length > 0) {
            this.defaultStopSign = this.defaultStopSign.filter(
              (list_stop_park) => list_stop_park.total_time >= 60
            )
          }

          this.showParking = true
          this.showStop = true
        })
        .catch((error) => {
          console.log(error)
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    markerStop() {
      this.stopSign = []
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/report/stop_report`, {
          params: {
            page: 1,
            per_page: 100,
            device: this.imei,
            start: `${this.input.start}:00`,
            end: `${this.input.end}:00`,
            min_time: 60,
            max_time: 60 * 60,
            playback: true
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)

          var data = res.data.message.data
          data.map((item, index) => {
            const start = item.start.split(' ')
            const end = item.end.split(' ')

            const dataSign = {
              position: L.latLng(item.lat, item.lon),
              index: index,
              icon: L.icon({
                iconUrl: this.publicPath + 'markers/stop.png',
                iconSize: [50, 50],
                iconAnchor: [25, 48]
              }),
              total_time: item.stop_time,
              status_name: 'Stop Time',
              color: '#000000',
              address: item.address,
              start: start[1],
              end: end[1]
            }

            if (item.stop_time >= 60) {
              this.stopSign.push(dataSign)
              this.marker_stop.push(dataSign)
            }

            this.defaultStopSign.push(dataSign)
          })
        })
        .catch((error) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    markerParking() {
      this.parkingSign = []
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/report/parking_report`, {
          params: {
            page: 1,
            per_page: 100,
            device: this.imei,
            start: `${this.input.start}:00`,
            end: `${this.input.end}:00`,
            min_time: 60,
            max_time: 1440 * 60,
            playback: true
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)

          var data = res.data.message.data
          data.map((item, index) => {
            const start = item.start.split(' ')
            const end = item.end.split(' ')

            const dataSign = {
              position: L.latLng(item.lat, item.lon),
              index: index,
              icon: L.icon({
                iconUrl: this.publicPath + 'markers/park.png',
                iconSize: [50, 50],
                iconAnchor: [25, 48]
              }),
              total_time: item.stop_time,
              status_name: 'Parking Time',
              color: '#479dd7',
              address: item.address,
              start: start[1],
              end: end[1]
            }

            if (item.stop_time >= 60) {
              this.parkingSign.push(dataSign)
              this.marker_parking.push(dataSign)
            }

            this.defaultStopSign.push(dataSign)
          })
        })
        .catch((error) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    reset() {
      this.play = false
      this.slider.step = 0
      this.stopPark = false
      this.stopSign = []
      this.markerStart.visible = true
    },

    // showStopPark() {
    //   if (!this.stopPark) {
    //     this.stopPark = true
    //     this.slider.step = this.slider.max
    //     this.stopSign = this.defaultStopSign
    //   } else {
    //     this.stopPark = false
    //     this.slider.step = 0
    //     this.stopSign = []
    //     this.play = false
    //   }
    // },

    setStop() {
      if (!this.showStop) {
        this.showStop = true
        this.stopSign = this.marker_stop
      } else {
        this.showStop = false
        this.stopSign = []
      }
    },

    setParking() {
      if (!this.showParking) {
        this.showParking = true
        this.parkingSign = this.marker_parking
      } else {
        this.showParking = false
        this.parkingSign = []
      }
    },

    toggleTrack() {
      if (this.trackType === 'line') {
        // toggle to dots
        this.trackType = 'dots'
      } else {
        // toggle to line
        this.trackType = 'line'
      }
    },

    exportTrack() {
      this.$vs.loading({
        background: 'warning',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      this.$http
        .get(`${this.$api.endpoint}/tracking/export`, {
          responseType: 'blob',
          params: {
            imei: this.imei,
            start: this.export.start,
            end: this.export.end
          },
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)

          let filename = `Tracks_${this.imei}_${this.export.start
            .toString()
            .substr(0, 10)}_${this.export.end.toString().substr(0, 10)}.xlsx`
          FileDownload(res.data, filename)
        })
        .catch((error) => {
          this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    strtotime(str) {
      let d = new Date(str)
      return d.getTime() / 1000
    },

    showPolygone(params) {
      if (params === 'poi') {
        this.clicks++
        if (this.clicks === 1) {
          this.timer = setTimeout(() => {
            this.show_hide[params] = !this.show_hide[params]
            this.isPermanentPoi = false
            this.clicks = 0

            if (this.show_hide[params] == true)
              this.show_hide_color[params] = 'primary'
            else this.show_hide_color[params] = 'white'
          }, 700)
        } else {
          clearTimeout(this.timer)
          this.show_hide[params] = !this.show_hide[params]
          this.isPermanentPoi = true
          this.clicks = 0

          if (this.show_hide[params] == true)
            this.show_hide_color[params] = 'primary'
          else this.show_hide_color[params] = 'white'
        }
      } else {
        this.show_hide[params] = !this.show_hide[params]
        if (this.show_hide[params] == true)
          this.show_hide_color[params] = 'primary'
        else this.show_hide_color[params] = 'white'
      }
    },

    secondsToHms(seconds) {
      // second = 172800
      seconds = Number(seconds)

      let days = seconds > 86400 ? Math.floor(seconds / 86400) : 0
      seconds = days > 0 ? seconds - days * 86400 : seconds

      let hour = Math.floor(seconds / 3600)
      let minute = Math.floor((seconds % 3600) / 60)
      let sec = Math.floor((seconds % 3600) % 60)

      let dDisplay = days > 0 ? days + (hour > 0 ? ' day(s) ' : ' day(s)') : ''
      let hDisplay = hour > 0 ? hour + (minute > 0 ? ' hr ' : '  hr') : ''
      let mDisplay = minute > 0 ? minute + (sec > 0 ? ' min ' : ' min') : ''
      let sDisplay = sec > 0 ? sec + ' sec' : ''
      return dDisplay + hDisplay + mDisplay + sDisplay
    },

    streetView() {
      if (this.tracks.length > 0) {
        let index = this.last_map_position.length
        let lat = this.last_map_position[index - 1].lat
        let lon = this.last_map_position[index - 1].lon

        let url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat}%2C${lon}&heading=-45&pitch=38&fov=80`

        window.open(
          url,
          '_blank',
          'toolbar=1, scrollbars=1, resizable=1, width=' +
            800 +
            ', height=' +
            500
        )
      } else {
        this.$vs.notify({
          title: 'Attention !',
          text: 'Data not found',
          color: 'warning',
          position: 'top-right'
        })
      }
    },

    openGoogleMap() {
      let index = this.last_map_position.length
      if (index > 0) {
        let lat = this.last_map_position[index - 1].lat
        let lon = this.last_map_position[index - 1].lon

        let url = `https://www.google.com/maps/@${lat},${lon},18z?hl=en-US&entry=ttu`

        window.open(url)
      } else {
        this.$vs.notify({
          title: 'Attention !',
          text: 'Vehicle not selected',
          color: 'warning',
          position: 'top-right'
        })
      }
    },

    set_speed() {
      this.play = !this.play
      if (this.speed_now < 3) {
        this.speed_now++
        this.speed_track = this.speed_track / this.speed_now
      } else {
        this.speed_now = 1
        this.speed_track = 1000
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/extraComponents/tree.scss';
</style>
